export default {
  'common.loading': 'Загрузка…',
  'common.saving': 'Сохранение…',
  'common.cancel': 'Отмена',
  'common.remove': 'Удалить',
  'common.close': 'Закрыть',

  'app.account': 'Аккаунт',
  'app.homeAria': 'Danny Top — на главную',
  'app.settings': 'Настройки',
  'app.logout': 'Выйти',
  // Гостевая главная (docs/guest-landing/SPEC.md)
  'guestLanding.eyebrow': 'Danny Top',
  'guestLanding.title': 'Инвестиции – под полным контролем',
  'guestLanding.description': 'Приложение для управления инвестициями: следите за капиталом, выплатами и структурой портфеля в одном месте.',
  'guestLanding.createAccount': 'Создать аккаунт',
  'guestLanding.hasAccount': 'Уже есть аккаунт? Войти',
  'guestLanding.feature.capital': 'Стоимость и доходность капитала',
  'guestLanding.feature.payouts': 'Выплаты и прогноз дохода',
  'guestLanding.feature.structure': 'Структура портфеля без лишнего',
  'guestLanding.feature.achievements': 'Личные достижения',
  'guestLanding.feature.strategies': 'Создание и управление стратегиями',
  'guestLanding.feature.news': 'Обзор новостей по вашим бумагам',
  'guestLanding.cardTitle': 'Ваш капитал',
  'guestLanding.cardPeriod': 'за всё время',
  'guestLanding.card.portfolio': 'Портфель',
  'guestLanding.card.payouts': 'Выплаты',
  'guestLanding.card.analytics': 'Аналитика',

  // Phone layout (docs/design/SPEC.md, stage M1)
  'nav.label': 'Разделы',
  'nav.portfolio': 'Портфель',
  'nav.markets': 'Рынки',
  'nav.news': 'Новости',
  'nav.profile': 'Профиль',
  'nav.profileAlert': 'Ключ API не задан',
  'selector.title': 'Портфель',
  'selector.aria': 'Портфель: {name}. Сменить',
  'live.on': 'Цены обновляются, {time}',
  'live.off': 'Цены не обновляются',
  'live.title': 'Цены',
  'live.onText': 'Цены обновляются каждые 5 секунд · {time}',
  'live.offText': 'Цены не обновляются. Показаны последние полученные. Проверьте интернет.',
  'live.snapshot': 'Количество бумаг и средняя цена — на {date}',
  'live.openProfile': 'Открыть профиль',
  'refresh.now': 'Обновить из Т-Инвестиций',
  'refresh.running': 'Обновляем из Т-Инвестиций…',
  'refresh.noKey': 'Ключ API удалён — данные брокера не обновить.',
  'refresh.pull': 'Потяните, чтобы обновить',
  'refresh.release': 'Отпустите, чтобы обновить',
  'common.retry': 'Повторить',
  'selector.manage': 'Управлять счетами',
  'home.allTimeSuffix': 'за всё время',
  'home.todaySuffix': 'за сегодня',
  'home.periodSwitch': 'Нажмите, чтобы переключить: за сегодня или за всё время',
  'accounts.title': 'Счета',
  'accounts.showAll': 'Все счета · {count}',
  'structure.title': 'Структура',
  'structure.types': 'Активы',
  'structure.sectors': 'Отрасли',
  'structure.companies': 'Компании',
  'structure.currencies': 'Валюты',
  'profile.title': 'Профиль',
  'profile.data': 'Данные',
  'profile.app': 'Приложение',
  'profile.refresh': 'Обновить данные',
  'profile.updatedAt': 'Данные брокера на {date}',
  'profile.accounts': 'Счета и портфели',
  'profile.apiKey': 'Ключ Т-Инвестиций',
  'profile.keySet': 'сохранён',
  'profile.keyMissing': 'не задан',
  'profile.needKey': 'Нужен ключ Т-Инвестиций',
  'profile.birthDate': 'Дата рождения',
  'empty.connectTitle': 'Подключите Т-Инвестиции',
  'empty.loadTitle': 'Загрузите счета',
  'goal.setMobile': 'Задать цель по выплатам',
  'calendar.emptyMobile': 'За этот период выплат нет. Потяните экран вниз, чтобы обновить данные.',
  'profile.import': 'Добавить счета из Т-Инвестиций',

  'auth.loginTab': 'Вход',
  'auth.registerTab': 'Регистрация',
  'auth.name': 'Имя',
  'auth.email': 'Email',
  'auth.password': 'Пароль',
  'auth.passwordConfirmation': 'Повторите пароль',
  'auth.signIn': 'Войти',
  'auth.signingIn': 'Входим…',
  'auth.createAccount': 'Создать аккаунт',
  'auth.sendingEmail': 'Отправляем письмо…',
  'auth.resend': 'Отправить письмо ещё раз',
  'auth.sessionEnded': 'Сессия завершилась. Войдите снова.',
  'auth.registerInvalid': 'Заполните все поля корректно и проверьте, что пароли совпадают.',
  'auth.confirmResend': 'Письмо с подтверждением уже отправлено, ссылка ещё действует. Отправить новое?',
  'auth.usePreviousLink': 'Можно воспользоваться ссылкой из предыдущего письма.',
  'auth.registerFailed': 'Не удалось зарегистрироваться',
  'auth.loginInvalid': 'Введите корректный email и пароль.',
  'auth.loginSuccess': 'Вы вошли в аккаунт',
  'auth.loginFailed': 'Не удалось войти',
  'auth.loggedOut': 'Вы вышли из аккаунта',
  'auth.logoutFailed': 'Не удалось выйти',
  'auth.resendFailed': 'Не удалось отправить письмо',
  'auth.verified': 'Email подтверждён, вы вошли в аккаунт.',
  'auth.verifyInvalid': 'Ссылка для подтверждения недействительна или устарела.',
  'auth.signInForSettings': 'Войдите, чтобы открыть настройки.',

  'settings.title': 'Настройки',
  'settings.home': 'На главную',
  'settings.profile': 'Профиль',
  'settings.namePlaceholder': 'Имя (необязательно)',
  'settings.saveProfile': 'Сохранить профиль',
  'settings.loadFailed': 'Не удалось загрузить настройки',
  'settings.profileSaveFailed': 'Не удалось сохранить профиль',
  'settings.language': 'Язык',
  'settings.languageHint': 'Язык интерфейса и писем. Сохраняется в профиле.',
  'settings.languageSaveFailed': 'Не удалось сохранить язык',
  'settings.locale.ru': 'Русский',
  'settings.locale.en': 'English',
  'settings.apiKeys': 'API-ключи',
  'settings.apiKeysHint': 'Один ключ на провайдера. Ключи хранятся на сервере в зашифрованном виде, после сохранения мы их больше не показываем.',
  'settings.source.TBANK': 'Т-Банк (Т-Инвестиции)',
  'settings.keySaved': 'сохранён',
  'settings.keyPlaceholder': 'Вставьте API-ключ',
  'settings.keyReplacePlaceholder': 'Введите новый ключ для замены',
  'settings.saveKey': 'Сохранить ключ',
  'settings.enterKey': 'Введите API-ключ перед сохранением.',
  'settings.keySaveFailed': 'Не удалось сохранить API-ключ',
  'settings.confirmRemoveKey': 'Удалить этот API-ключ?',
  'settings.keyRemoveFailed': 'Не удалось удалить API-ключ',

  'portfolios.load': 'Загрузить из Т-Инвестиций',
  'portfolios.refreshAll': 'Обновить все',
  'portfolios.refreshing': 'Обновляем…',
  'portfolios.needKey': 'Сохраните API-ключ Т-Инвестиций (только чтение), чтобы загрузить портфели.',
  'portfolios.openSettings': 'Открыть настройки',
  'portfolios.empty': 'Портфели ещё не загружены.',
  'portfolios.keyRemoved': 'API-ключ Т-Банка удалён: показаны последние загруженные данные, обновление недоступно.',
  'portfolios.skipped': 'Пропущено: {count} (счёт закрыт или недоступен для этого ключа).',
  'portfolios.loadFailed': 'Не удалось загрузить портфели',
  'portfolios.refreshFailed': 'Не удалось обновить',
  'portfolios.confirmRemove': 'Удалить «{name}» из приложения? Счёт в Т-Банке это не затронет.',
  'portfolios.removeFailed': 'Не удалось удалить портфель',
  'portfolios.live': 'Живые цены · {time}',
  'portfolios.capital': 'Капитал',
  'portfolios.select': 'Выбор портфеля',
  'portfolios.accountsSection': 'Счета',
  'portfolios.groupsSection': 'Составные',
  'portfolios.newGroup': '+ Составной портфель',
  'portfolios.confirmRemoveGroup': 'Удалить составной портфель «{name}»? Счета останутся.',
  'portfolios.removeGroupFailed': 'Не удалось удалить составной портфель',

  'portfolio.updated': 'обновлено {date}',
  'portfolio.livePrice': 'Живая цена, {time}',
  'portfolio.pcs': '{n} шт',
  'portfolio.avgToCurrent': 'Средняя цена покупки → текущая цена',
  'portfolio.fifo': 'По FIFO: {price}',
  'portfolio.blocked': 'заблокировано',
  'portfolio.shareHint': 'Доля в стоимости портфеля',
  'portfolio.sort': 'Сортировка',
  'portfolio.sort.value': 'Сумма',
  'portfolio.sort.name': 'Название',
  'portfolio.sort.yieldAbs': 'Прирост ₽',
  'portfolio.sort.yieldPercent': 'Прирост %',
  'portfolio.sort.reverse': 'Обратный порядок',
  'portfolio.sort.bySector': 'По секторам',
  'portfolio.sort.nameGlyph': 'А–Я',
  'portfolio.noPositions': 'Позиций нет.',
  'portfolio.gainPeriod': 'Прирост {period}',
  'portfolio.refresh': 'Обновить',
  'portfolio.remove': 'Удалить из приложения',
  'calendar.title': 'Календарь выплат',
  'calendar.period': 'Период календаря',
  'calendar.next12': '12 мес. вперёд',
  'calendar.total': 'Всего',
  'calendar.perMonth': 'В месяц',
  'calendar.perMonthInline': '≈ {amount} в месяц',
  'calendar.dividends': 'Дивиденды',
  'calendar.coupons': 'Купоны',
  'calendar.tax': 'Налог',
  'calendar.taxHint': 'Налог, удержанный с полученных дивидендов и купонов. Суммы выплат — до налога.',
  'calendar.maturities': 'Погашения',
  'calendar.maturityHint': 'Возврат номинала облигаций, в «Всего» не входит',
  'calendar.passiveHint': 'Дивиденды и купоны за 12 мес. вперёд после налога 13 % к текущей стоимости портфеля — как в «Аналитике»',
  'calendar.empty': 'За этот период выплат нет. Если данные ещё не загружались, нажмите «Обновить все» в меню профиля.',
  'calendar.chartLabel': 'Выплаты по периодам',
  'calendar.bucketEmpty': 'Выплат нет.',
  'calendar.series.paid': 'Выплачено',
  'calendar.series.declared': 'Объявлено',
  'calendar.series.forecast': 'Прогноз',
  'calendar.series.maturity': 'Погашения',
  'calendar.noInstrument': 'Без привязки к бумаге',
  'calendar.taxOnly': 'налог {tax}',
  'calendar.withTax': '{gross} − налог {tax}',
  'calendar.kind.dividend': 'Дивиденд',
  'calendar.kind.coupon': 'Купон',
  'calendar.kind.maturity': 'Погашение',
  'calendar.kind.dividend_tax': 'Налог с дивиденда',
  'calendar.kind.coupon_tax': 'Налог с купона',
  'calendar.status.paid': 'выплачено',
  'calendar.status.paidHint': 'Деньги пришли на счёт',
  'calendar.status.declared': 'объявлено',
  'calendar.status.declaredHint': 'Выплата объявлена, ждём поступления',
  'calendar.status.recommended': 'объявлено',
  'calendar.status.recommendedHint': 'Рекомендация совета директоров, собрание акционеров ещё впереди',
  'calendar.status.awaiting': 'ожидается',
  'calendar.status.awaitingHint': 'Отсечка прошла, ждём поступления',
  'calendar.status.forecast': 'прогноз',
  'calendar.status.forecastHint': 'Оценка: прогноз аналитиков, повтор прошлогодней выплаты или последний известный купон',
  'calendar.status.unknown': 'сумма неизвестна',
  'calendar.status.unknownHint': 'Размер выплаты ещё не определён',
  'calendar.amountUnknown': 'не определена',
  'calendar.loadFailed': 'Не удалось загрузить календарь выплат',
  'sections.label': 'Разделы',
  'sections.portfolio': 'Портфель',
  'sections.markets': 'Рынки',
  'sections.strategy': 'Управление стратегией',
  'sections.news': 'Новости',
  'sections.portfolioShort': 'Портфель',
  'sections.cashflowShort': 'Выплаты',
  'sections.analyticsShort': 'Аналитика',
  'portfolios.keyRemovedShort': 'Ключ API удалён ·',
  'summary.value': 'Стоимость',
  'summary.valueHint': 'Текущая стоимость портфеля. Цены обновляются в реальном времени, пока работает биржа; бумаги в валюте пересчитаны по курсу ЦБ на сегодня. Вложено — стоимость текущих бумаг по средней цене покупки.',
  'summary.assetsValue': 'Стоимость активов',
  'summary.cashValue': 'Валюта и кэш',
  'summary.invested': '{amount} вложено',
  'summary.profit': 'Прибыль',
  'summary.profitHint': 'Верхнее значение — прибыль от изменения цены текущих бумаг относительно средней цены покупки (по данным брокера), без дивидендов, купонов и проданных бумаг. Нижнее — изменение за последний день работы биржи.',
  'summary.perDay': 'Сегодня',
  'summary.passive': 'Пассивный доход',
  'summary.passiveHint': 'Дивиденды и купоны за будущие 12 месяцев, как «Всего» в календаре выплат: объявленные, рекомендованные и прогноз. Погашения не учитываются. Суммы после налога 13%. Крупная цифра — доходность к текущей стоимости портфеля, зелёная — к вложенному.',
  'summary.onInvested': '{percent} от вложенного',
  'summary.perYear': '{amount} в год',
  'analytics.empty': 'Нет позиций с известной стоимостью',
  'analytics.skipped': 'Не учтено позиций без цены или курса валюты: {count}',
  'analytics.types': 'Типы активов',
  'analytics.sectors': 'Секторы',
  'analytics.allSectors': 'Все секторы',
  'analytics.companies': 'Компании',
  'analytics.companiesCount': 'бумаг: {count}',
  'analytics.top5': 'Топ-5 — {percent}',
  'analytics.top10': 'Топ-10 — {percent}',
  'analytics.othersRing': 'Остальные бумаги: {count}',
  'analytics.showAll': 'Показать все {count}',
  'analytics.showMore': 'Показать ещё {count}',
  'analytics.showLess': 'Свернуть',
  'analytics.expandAll': 'Развернуть все',
  'analytics.itemsCount': 'Бумаг: {count}',
  'analytics.collapseAll': 'Свернуть все',
  'analytics.currencies': 'Валюты',
  'analytics.total': 'Всего',
  'analytics.securities': 'Бумаги',
  'analytics.cash': 'Валюта и кэш',
  'performance.title': 'Рост портфеля',
  'performance.mode.return': 'Доходность',
  'performance.mode.value': 'Стоимость',
  'performance.period.1m': '1М',
  'performance.period.3m': '3М',
  'performance.period.6m': '6М',
  'performance.period.1y': '1Г',
  'performance.period.ytd': 'С начала года',
  'performance.period.all': 'Всё время',
  'performance.index': 'Индекс',
  'performance.indexName.MCFTRR': 'Акции, нетто (MCFTRR)',
  'performance.indexName.MCFTR': 'Акции, брутто (MCFTR)',
  'performance.indexName.RGBITR': 'Гособлигации (RGBITR)',
  'performance.legend.portfolio': 'Портфель',
  'performance.legend.value': 'Стоимость',
  'performance.legend.invested': 'Вложено',
  'performance.income': 'Доход за период',
  'performance.netFlow': 'Пополнения − выводы',
  'performance.ahead': 'Ваш портфель обгоняет {index} на {money} и {percent}',
  'performance.behind': 'Ваш портфель отстаёт от {index} на {money} и {percent}',
  'performance.aheadPercentBehindMoney': 'Ваш портфель обгоняет {index} на {percent}, но в рублях отстаёт на {money}',
  'performance.behindPercentAheadMoney': 'Ваш портфель отстаёт от {index} на {percent}, но в рублях обгоняет на {money}',
  'performance.pending': 'История считается по операциям — обычно это занимает меньше минуты.',
  'performance.updating': 'История обновляется…',
  'performance.error': 'Не удалось посчитать историю. Попробуйте обновить портфель.',
  'performance.empty': 'Истории пока нет.',
  'performance.loadFailed': 'Не удалось загрузить историю.',
  'performance.since': 'История начинается {date}',
  'performance.wholeAccounts': 'История — по входящим счетам целиком, без выбора бумаг',
  'performance.mismatches': 'Расхождений с брокером: {count} — график может быть неточным',
  'performance.hint.twr': 'Доходность взвешена по времени (TWR): пополнения и выводы на неё не влияют, поэтому её можно сравнивать с индексом. Рубли индекса — сколько он заработал бы на тех же деньгах: та же стоимость в начале периода, те же пополнения и выводы в те же дни. История восстановлена по операциям и дневным ценам, с даты загрузки — по итогам брокера.',
  'performance.hint.indexes': 'MCFTRR и MCFTR — индексы МосБиржи полной доходности (с дивидендами): нетто — после налога для резидентов, брутто — до налога. RGBITR — гособлигации с купонами.',
  'performance.withInflation': '+ инфляция',
  'performance.legend.inflation': 'Инфляция',
  'performance.legend.investedReal': 'Вложено + инфляция',
  'performance.inflation.ahead': 'Ваш портфель обгоняет инфляцию на {money} и {percent}',
  'performance.inflation.behind': 'Ваш портфель отстаёт от инфляции на {money} и {percent}',
  'performance.inflation.aheadPercentBehindMoney': 'Ваш портфель обгоняет инфляцию на {percent}, но в рублях отстаёт на {money}',
  'performance.inflation.behindPercentAheadMoney': 'Ваш портфель отстаёт от инфляции на {percent}, но в рублях обгоняет на {money}',
  'performance.inflationUntil': 'Инфляция — по {date}: Росстат публикует её с задержкой, сравнение с ней — на эту дату',
  'performance.hint.inflation': 'Инфляция — индекс потребительских цен Росстата: помесячный, последние недели — по недельной оценке. Рубли инфляции — сколько нужно было заработать, чтобы просто не обеднеть. «Вложено + инфляция» — каждое пополнение и вывод, выросшие на инфляцию со своего дня.',
  'performance.aria.value': 'Стоимость {value}, доход за период {income}',
  'performance.aria.return': 'Доходность портфеля {portfolio}, индекс {index} {indexValue}',
  'sector.energy': 'Нефть и газ',
  'sector.utilities': 'Электроэнергетика',
  'sector.materials': 'Сырьё и материалы',
  'sector.financial': 'Финансы',
  'sector.real_estate': 'Недвижимость',
  'sector.consumer': 'Потребительский сектор',
  'sector.it': 'IT',
  'sector.telecom': 'Телеком',
  'sector.industrials': 'Промышленность',
  'sector.health_care': 'Здравоохранение',
  'sector.other': 'Прочее',
  'sector.government': 'Гос. и муниципальные облигации',
  'sector.funds': 'Фонды',
  'sector.cash': 'Валюта и кэш',
  'sector.unlabelled': 'Без отрасли',
  'goal.title': 'Цель по выплатам',
  'goal.set': 'Цель по выплатам',
  'goal.hint': 'в рублях; сравнивается с выплатами на 12 мес. вперёд',
  'goal.period': 'Период цели',
  'goal.per.month': 'В месяц',
  'goal.per.year': 'В год',
  'goal.amount': 'Сумма',
  'goal.label.month': 'Цель: {amount}/мес',
  'goal.label.year': 'Цель: {amount}/год',
  'goal.progress.month': '≈ {value} в месяц из {target}',
  'goal.progress.year': '{value} за 12 мес. из {target}',
  'goal.save': 'Сохранить',
  'goal.remove': 'Удалить цель',
  'goal.invalidAmount': 'Введите сумму больше нуля.',
  'goal.saveFailed': 'Не удалось сохранить цель',
  'portfolio.composite': 'Составной портфель',
  'portfolio.capitalHint': 'Все счета',
  'portfolio.accountCount': 'счетов: {count}',
  'portfolio.edit': 'Изменить',
  'portfolio.removeGroup': 'Удалить портфель',
  'portfolio.outsideTotal': 'не в итоге',
  'portfolio.outsideTotalHint': 'Для этой валюты нет курса ЦБ: в итог портфеля не входит',
  'group.titleNew': 'Новый составной портфель',
  'group.titleEdit': 'Составной портфель',
  'group.name': 'Название',
  'group.accounts': 'Счета и бумаги',
  'group.allAssets': 'Все бумаги ({count})',
  'group.someAssets': 'Бумаги: {selected} из {count}',
  'group.allAssetsToggle': 'Все бумаги',
  'group.allAssetsHint': 'Пока отмечены все, новые бумаги счёта попадут в портфель автоматически.',
  'group.needName': 'Введите название.',
  'group.needAccount': 'Отметьте хотя бы один счёт.',
  'group.needAsset': 'Отметьте хотя бы одну бумагу в счёте «{name}».',
  'group.save': 'Сохранить',
  'group.saveFailed': 'Не удалось сохранить составной портфель',

  'import.title': 'Загрузка портфелей из Т-Инвестиций',
  'import.hint': 'Выберите счета для загрузки. Уже загруженные будут обновлены.',
  'import.loadingAccounts': 'Загружаем счета…',
  'import.allAccounts': 'Все счета',
  'import.loaded': 'загружен',
  'import.noAccounts': 'Для этого ключа не найдено открытых счетов.',
  'import.submit': 'Загрузить ({count})',
  'import.accountsFailed': 'Не удалось получить счета из Т-Инвестиций',
  'import.failed': 'Не удалось загрузить',

  'accountType.ACCOUNT_TYPE_TINKOFF': 'Брокерский счёт',
  'accountType.ACCOUNT_TYPE_TINKOFF_IIS': 'ИИС',
  'accountType.ACCOUNT_TYPE_INVEST_BOX': 'Инвесткопилка',
  'accountType.ACCOUNT_TYPE_INVEST_FUND': 'Фонд',
  'accountType.ACCOUNT_TYPE_DEBIT': 'Дебетовый счёт',
  'accountType.ACCOUNT_TYPE_SAVING': 'Накопительный счёт',
  'accountType.other': 'Счёт',

  'instrumentType.share': 'Акции',
  'instrumentType.bond': 'Облигации',
  'instrumentType.etf': 'Фонды',
  'instrumentType.currency': 'Валюта',
  'instrumentType.futures': 'Фьючерсы',
  'instrumentType.option': 'Опционы',
  'instrumentType.sp': 'Структурные ноты',
  'instrumentType.other': 'Другое',

  'lock.enterPin': 'Введите PIN',
  'lock.locked': 'Приложение заблокировано',
  'lock.entered': 'Введено {n} из {total}',
  'lock.keypad': 'Клавиатура PIN',
  'lock.deleteDigit': 'Удалить цифру',
  'lock.signInWith': 'Войти с {methodIns}',
  'lock.checking': 'Проверяем…',
  'lock.wrongPin': 'Неверный PIN. Осталось попыток: {n}',
  'lock.wrongPinLast': 'Неверный PIN. Осталась 1 попытка, затем выход',
  'lock.tooManyAttempts': 'Слишком много неверных попыток. Войдите с паролем.',
  'lock.network': 'Нет связи с сервером. Проверьте интернет.',
  'lock.retry': 'Повторить',
  'lock.failed': 'Не удалось разблокировать. Попробуйте ещё раз.',
  'lock.passkeyFailedPin': 'Не удалось подтвердить {methodAcc}. Введите PIN.',
  'lock.passkeyFailedRetry': 'Не удалось подтвердить {methodAcc}. Попробуйте ещё раз.',

  'security.title': 'Безопасность',
  'security.hint': 'Приложение блокируется при открытии и после 5 минут в фоне.',
  'security.unsupported': 'Этот браузер не поддерживает вход без пароля.',
  'security.passkeyOn': 'Вход по {methodDat} включён на этом устройстве',
  'security.passkeyAddFailed': 'Не удалось добавить устройство',
  'security.pin': 'PIN-код',
  'security.changePin': 'Сменить PIN',
  'security.confirmPassword': 'Подтвердите паролем',
  'security.continue': 'Продолжить',
  'security.wrongPassword': 'Неверный пароль',
  'security.choosePin': 'Придумайте PIN из 4 цифр',
  'security.repeatPin': 'Повторите PIN',
  'security.pinMismatch': 'PIN не совпадает. Придумайте заново.',
  'security.pinSaved': 'PIN сохранён',
  'security.failed': 'Не удалось выполнить действие',

  'onboarding.pinHint': 'Его нужно будет вводить при открытии приложения.',
  'onboarding.faceIdTitle': 'Использовать {methodAcc}?',
  'onboarding.faceIdHint': 'Открывайте приложение по {methodDat} вместо ввода PIN.',
  'onboarding.faceIdUse': 'Использовать {methodAcc}',
  'onboarding.faceIdSkip': 'Не сейчас',
  'security.faceIdOnDevice': '{methodCap} на этом устройстве',
  'security.faceIdHint': 'Открывать приложение по {methodDat} вместо PIN.',
  'security.passkeyOff': 'Вход по {methodDat} выключен на этом устройстве',
  'security.pinHint': 'Новый PIN нужно придумывать после каждого входа с паролем.',

  'notifications.title': 'Уведомления',
  'notifications.hint': 'О выплатах, объявленных дивидендах и отсечках по бумагам из портфеля.',
  'notifications.device': 'Уведомления на этом устройстве',
  'notifications.event.payout_received': 'Выплата пришла на счёт',
  'notifications.event.dividend_declared': 'Объявлен дивиденд',
  'notifications.event.record_date': 'Отсечка через 3 дня',
  'notifications.event.achievement': 'Новое достижение',
  'notifications.test': 'Проверить уведомление',
  'notifications.on': 'Уведомления включены на этом устройстве',
  'notifications.off': 'Уведомления выключены на этом устройстве',
  'notifications.failed': 'Не удалось изменить уведомления',
  'notifications.denied': 'Уведомления запрещены в настройках телефона или браузера',
  'notifications.homeScreen': 'Добавьте приложение на экран «Домой»: в Safari «Поделиться» → «На экран Домой»',
  'notifications.unsupported': 'Этот браузер не поддерживает уведомления',
  'notifications.notConfigured': 'Уведомления не настроены на сервере',

  'common.soon': 'Скоро',
  'common.inDevelopment': 'В разработке',
  'home.operations': 'Операции',
  'home.payouts': 'Выплаты',
  'home.analytics': 'Аналитика',
  'home.achievements': 'Достижения',
  'achievements.best': 'лучшее',
  'achievements.aheadLeft': 'впереди · ещё {left}',
  'achievements.streakIsBest': 'Это ваша лучшая серия',
  'achievements.stepGroup.other': '{from} → {to} · сразу {count} шага',
  'achievements.stepGroup.many': '{from} → {to} · сразу {count} шагов',
  'achievements.stepGroup.few': '{from} → {to} · сразу {count} шага',
  'achievements.stepGroup.one': '{from} → {to} · {count} шаг за день',
  'achievements.firstVsLast.other': 'Первые {step} — {first}, последние {count} шага — в среднем по {days}',
  'achievements.firstVsLast.many': 'Первые {step} — {first}, последние {count} шагов — в среднем по {days}',
  'achievements.firstVsLast.few': 'Первые {step} — {first}, последние {count} шага — в среднем по {days}',
  'achievements.firstVsLast.one': 'Первые {step} — {first}, последний {count} шаг — {days}',
  'achievements.averageOne': 'Первый шаг — {days}',
  'achievements.from': 'от {level}',
  'achievements.freshTitle': 'Новый рубеж — {level}',
  'achievements.loadFailed': 'Не удалось загрузить достижения',
  'achievements.empty': 'Достижения появятся, когда посчитается история стоимости — обычно ночью',
  'achievements.nextTitle': 'Следующий рубеж',
  'achievements.left': 'Осталось {sum}',
  'achievements.forecastDay': 'Около {date} — по темпу',
  'achievements.forecastMonth': 'Около {date} — по темпу',
  'achievements.forecastYear': 'Около {year} г. — по темпу',
  'achievements.forecast.short': 'Прогноз появится, когда наберётся 3 месяца истории',
  'achievements.forecast.flat': 'Прогноза нет: за полгода портфель не вырос. Каждое пополнение приближает рубеж',
  'achievements.forecast.far': 'При нынешнем темпе — больше 5 лет',
  'achievements.forecastHintLabel': 'Как считается прогноз',
  'achievements.forecastHint': 'Средний темп за последние 6 месяцев: пополнения и рост цен. Изменится темп — сдвинется и дата.',
  'achievements.belowLevel': 'Рубеж {level} остаётся вашим: сейчас ниже на {sum}',
  'achievements.now': 'Сейчас',
  'achievements.invested': 'Вложено',
  'achievements.market': 'Рынок',
  'achievements.freshWhen': '{date}, за {days}',
  'achievements.allLevels': 'Все рубежи · {count}',
  'achievements.levelsTitle': 'Рубежи',
  'achievements.ladder.capital': 'Портфель',
  'achievements.ladder.shares': 'Акции',
  'achievements.onTheWayShort': 'в пути {days}',
  'achievements.until': 'до {level} — {sum}',
  'achievements.in': 'за {days}',
  'achievements.fastest': 'быстрее всего',
  'achievements.firstLevel': 'Первый рубеж — {level}',
  'achievements.firstSteps': 'Первые шаги · {from} → {to} · {count}',
  'achievements.atStartRow': 'На старте: {from} – {to} · {count}',
  'achievements.comebackTitle': 'Вы вернулись в {month} после {months} мес. паузы',
  'achievements.comebackText': 'Считать путь с возвращения? Прошлое останется в ленте.',
  'achievements.comebackAccept': 'Считать с {month}',
  'achievements.comebackDismiss': 'Не надо',
  'achievements.stepsTitle': 'Каждые {step}',
  'achievements.step': 'Шаг',
  'achievements.average': 'Последние 5 шагов — в среднем {days}',
  'achievements.averageAll.one': 'Все {count} шаг — в среднем {days}',
  'achievements.averageAll.few': 'Все {count} шага — в среднем {days}',
  'achievements.averageAll.many': 'Все {count} шагов — в среднем {days}',
  'achievements.averageAll.other': 'Все {count} шага — в среднем {days}',
  'achievements.firstStep': 'Первый шаг в {step} ещё в пути — столбцы появятся, когда портфель его пройдёт',
  'achievements.daysAxis': 'дн.',
  'achievements.stepDone': '{range} · {days} · {from} — {to}',
  'achievements.stepGoing': '{range} · в пути {days} · осталось {sum}',
  'achievements.atStartRange': 'Серая полоса — шаги, пройденные до начала отсчёта (до {level})',
  'achievements.put': 'Внёс {sum}',
  'achievements.marketGave': 'рынок {sum}',
  'achievements.marketLegend': 'рынок дал больше половины шага',
  'achievements.pathTitle': 'Путь',
  'achievements.pathEmpty': 'Первая веха появится с первой сделкой',
  'achievements.pathAll': 'Весь путь · {count}',
  'achievements.path.capital': 'Портфель — {level}',
  'achievements.path.firstMillion': 'Первый миллион',
  'achievements.path.capitalFrom': '{date} · за {days} от {level}',
  'achievements.path.capitalStart': '{date} · за {days} с начала отсчёта',
  'achievements.path.firstTrade': 'Первая сделка — {ticker}',
  'achievements.path.firstDividend': 'Первый дивиденд — {ticker}',
  'achievements.path.firstCoupon': 'Первый купон — {ticker}',
  'achievements.path.years.one': '{count} год на рынке',
  'achievements.path.years.few': '{count} года на рынке',
  'achievements.path.years.many': '{count} лет на рынке',
  'achievements.path.years.other': '{count} года на рынке',
  'achievements.path.comeback': 'Возвращение после {months} мес. паузы',
  'achievements.path.streak': '{months} мес. пополнений подряд',
  'achievements.path.income': 'Пассивный доход — около {level} в месяц',
  'achievements.path.drawdown': 'Пережили просадку −{depth} % без вывода денег',
  'achievements.path.max10': 'Ни одна бумага не больше 10 % портфеля',
  'achievements.path.sectors': 'Капитал в {count} секторах',
  'achievements.firstRun': 'Первый заход · {from} — {to}',
  'achievements.beforeStart': 'До отсчёта · {from} — {to}',
  'achievements.beforeBest': 'лучший результат — {level} · вех: {count}',
  'achievements.habitsTitle': 'Ваши привычки',
  'achievements.habit.streak': 'Пополняю каждый месяц',
  'achievements.habit.income': 'Пассивный доход',
  'achievements.habit.drawdown': 'Выдержка',
  'achievements.habit.diversity': 'Разнообразие',
  'achievements.monthsShort': '{count} мес.',
  'achievements.perMonth': '≈ {sum}/мес.',
  'achievements.streakWaiting': 'В этом месяце пополнения ещё нет — серия сохранится до {day}-го',
  'achievements.streakBestNext': 'Это лучшая серия · до {level} мес. — {left} мес.',
  'achievements.streakBest': 'Лучшая серия — {best} мес.',
  'achievements.streakRule': 'Месяц засчитан, если вы пополнили счёт хотя бы на 500 ₽',
  'achievements.incomeYear': 'за 12 мес., после налога',
  'achievements.incomeMonths.one': 'за {count} мес., после налога',
  'achievements.incomeMonths.few': 'за {count} мес., после налога',
  'achievements.incomeMonths.many': 'за {count} мес., после налога',
  'achievements.incomeMonths.other': 'за {count} мес., после налога',
  'achievements.incomeTotals': 'За 12 мес. — {year}, с начала отсчёта — {total}',
  'achievements.drawdownLived': 'Пережили просадку и не выводили деньги',
  'achievements.drawdownNone': 'Просадок от 10 % пока не было',
  'achievements.drawdownNow': 'Сейчас просадка −{depth} % · за это время вы внесли {sum}',
  'achievements.drawdownNowShort': 'Сейчас −{depth} %',
  'achievements.drawdownDates': 'с {from} до {to}',
  'achievements.sectorsCount.one': '{count} сектор',
  'achievements.sectorsCount.few': '{count} сектора',
  'achievements.sectorsCount.many': '{count} секторов',
  'achievements.sectorsCount.other': '{count} сектора',
  'achievements.largestShare': 'Крупнейшая бумага — {ticker}, {share} %',
  'achievements.max10Since': 'Ни одна бумага не больше 10 % — с {date}',
  'achievements.max10Not': 'Достижение «ни одна бумага не больше 10 %» пока впереди',
  'achievements.rule.streak': 'Месяц засчитан, если за него вы пополнили счёт хотя бы на 500 ₽; выводы не мешают. Текущий месяц не рвёт серию до его конца.',
  'achievements.rule.income': 'Дивиденды и купоны после налога за последние 12 месяцев, делённые на 12.',
  'achievements.rule.drawdown': 'Портфель упал на 10 % и больше от прошлого максимума (без учёта пополнений), вернулся к нему — и вы не выводили деньги.',
  'achievements.rule.diversity': 'Секторы с долей от 2 % портфеля. «Не больше 10 %» — 30 дней подряд ни одна бумага не дороже 10 % портфеля; фонды и деньги не считаются.',
  'achievements.levels': 'Уровни',
  'achievements.ahead': 'впереди',
  'achievements.counting': 'Считаем…',
  'achievements.startRow': 'Отсчёт с {date}',
  'achievements.startRowReturn': 'Отсчёт с возвращения — {date}',
  'achievements.startRowCustom': 'Отсчёт с {date} · своя дата',
  'achievements.startTitle': 'Точка старта',
  'achievements.startHint': 'С какого дня считать путь. Уровни, которые уже были к этой дате, отметятся «на старте», прошлое останется в ленте.',
  'achievements.startFirst': 'С первой операции — {date}',
  'achievements.startReturn': 'С возвращения — {date}',
  'achievements.startReturnNote': 'после {months} мес. паузы, {month}',
  'achievements.startCustom': 'Своя дата',
  'achievements.save': 'Сохранить',
  'achievements.saveFailed': 'Не удалось сохранить',
  'achievements.days.one': '{count} день',
  'achievements.days.few': '{count} дня',
  'achievements.days.many': '{count} дней',
  'achievements.days.other': '{count} дня',
  // IIS deduction limit (docs/iis/SPEC.md)
  'iis.title': 'Пополнения ИИС в {year}',
  'iis.left': 'Осталось внести {sum}',
  'iis.done': 'Лимит на {year} выполнен',
  'iis.forDeduction': 'для получения максимального вычета',
  'iis.notLoaded': 'Пополнения ещё не загружены',
  'settings.iisLimit': 'Остаток взносов на ИИС',
  'settings.iisLimitHint': 'Сколько внести в этом году на ИИС до максимального вычета (400 000 ₽)',
  'settings.preferencesSaveFailed': 'Не удалось сохранить настройку',
  // News (docs/news/SPEC.md)
  'news.title': 'Новости',
  'news.source': 'MarketTwits в Telegram',
  'news.onlyMine': 'Только мои бумаги',
  'news.emptyMine': 'Новостей по вашим бумагам пока нет',
  'news.noTickers': 'В портфелях нет бумаг, по которым можно искать новости',
  'news.empty': 'Новостей пока нет',
  'news.showAll': 'Показать все новости',
  'news.edited': 'изменено',
  'news.mediaOnly': 'Фото или видео',
  'news.more': 'Показать полностью',
  'news.less': 'Свернуть',
  'news.loadMore': 'Показать ещё',
  'news.end': 'Это все новости',
  'news.loadFailed': 'Не удалось загрузить новости',
  'news.loadMoreFailed': 'Не удалось загрузить',
  'news.filter': 'Фильтр',
  'news.filterTitle': 'Фильтр по тегам',
  'news.searchTags': 'Поиск тега',
  'news.noTagsFound': 'Теги не найдены',
  'news.showAllTags': 'Все ({count})',
  'news.category.ticker': 'Тикеры',
  'news.category.country': 'Страна',
  'news.category.commodity': 'Сырьё',
  'news.category.industry': 'Отрасль',
  'news.category.monetary': 'Денежная политика',
  'news.category.corporate': 'Корпоративные действия',
  'news.category.politics': 'Политика и персоны',
  'news.category.organization': 'Организации',
  'news.category.other': 'Другое',
  'news.tickerKind.share_ru': 'акции РФ',
  'news.tickerKind.share_foreign': 'иностранные акции',
  'news.tickerKind.crypto': 'крипта',
  'news.tickerKind.index': 'индексы',
  'news.tickerKind.currency': 'валюты',
  'news.tickerKind.commodity_quote': 'товарные котировки',
  'news.tickerKind.other': 'прочие',
  'news.modeLabel': 'Как сочетать теги',
  'news.mode.or': 'ИЛИ',
  'news.mode.and': 'И',
  'news.removeTag': 'Убрать {tag} из фильтра',
  'news.clearFilter': 'Сбросить',
  'news.emptyFilter': 'Нет новостей с таким фильтром',
  'news.addToFilter': 'Добавить в фильтр',
  'operations.title': 'Операции',
  'operations.backHome': 'Портфель',
  'operations.back': 'Назад',
  'operations.syncedAt': 'Данные на {date}',
  'operations.notSynced': 'по {count} счетам ещё не загружены',
  'operations.filter': 'Категории',
  'operations.all': 'Все',
  'operations.reset': 'Сбросить',
  'operations.resetFilter': 'Сбросить фильтр',
  'operations.count.one': '{count} операция',
  'operations.count.few': '{count} операции',
  'operations.count.many': '{count} операций',
  'operations.count.other': '{count} операции',
  'operations.cat.trades': 'Сделки',
  'operations.cat.fees': 'Комиссии',
  'operations.cat.taxes': 'Налоги',
  'operations.cat.varmargin': 'Вармаржа',
  'operations.cat.repayments': 'Погашения',
  'operations.cat.income': 'Дивиденды и купоны',
  'operations.cat.deposits': 'Пополнения',
  'operations.cat.withdrawals': 'Выводы',
  'operations.cat.transfers': 'Переводы',
  'operations.cat.other': 'Другое',
  'operations.period': 'Период',
  'operations.periodAll': 'Всё время',
  'operations.customPeriod': 'Свои даты',
  'operations.from': 'С',
  'operations.to': 'По',
  'operations.apply': 'Показать',
  'operations.forYear': 'за {year}',
  'operations.forPeriod': 'за период',
  'operations.forAllTime': 'за всё время',
  'operations.qty': '{qty} шт',
  'operations.qtyPrice': '{qty} шт по {price}',
  'operations.accrued': 'НКД {amount}',
  'operations.unknownType': 'Операция',
  'operations.emptyNotLoaded': 'Операции ещё не загружены',
  'operations.emptyNotLoadedText': 'Они загрузятся ночью или при обновлении данных.',
  'operations.loadNow': 'Загрузить сейчас',
  'operations.empty': 'Операций пока нет',
  'operations.emptyFilter': 'Нет операций с таким фильтром',
  'operations.noAccounts': 'В портфеле нет счетов',
  'operations.loadMore': 'Показать ещё',
  'operations.loadFailed': 'Не удалось загрузить операции',
  'operations.loadMoreFailed': 'Не удалось загрузить',
  'operations.end': 'Это все операции · первая — {date}',
  'opType.1': 'Пополнение',
  'opType.2': 'Налог с купона',
  'opType.3': 'Списание бумаг',
  'opType.4': 'Доход от овернайта',
  'opType.5': 'Налог',
  'opType.6': 'Погашение',
  'opType.7': 'Продажа на карту',
  'opType.8': 'Налог с дивидендов',
  'opType.9': 'Вывод',
  'opType.10': 'Амортизация',
  'opType.11': 'Корректировка налога',
  'opType.12': 'Обслуживание счёта',
  'opType.13': 'Налог с материальной выгоды',
  'opType.14': 'Комиссия за маржинальную позицию',
  'opType.15': 'Покупка',
  'opType.16': 'Покупка с карты',
  'opType.17': 'Зачисление бумаг',
  'opType.18': 'Продажа (маржин-колл)',
  'opType.19': 'Комиссия брокера',
  'opType.20': 'Покупка (маржин-колл)',
  'opType.21': 'Дивиденды',
  'opType.22': 'Продажа',
  'opType.23': 'Купон',
  'opType.24': 'Комиссия за результат',
  'opType.25': 'Передача дивидендного дохода',
  'opType.26': 'Вармаржа: зачисление',
  'opType.27': 'Вармаржа: списание',
  'opType.28': 'Покупка при экспирации',
  'opType.29': 'Продажа при экспирации',
  'opType.30': 'Автоследование: управление',
  'opType.31': 'Автоследование: результат',
  'opType.32': 'Налог 15 %',
  'opType.33': 'Налог с купона 15 %',
  'opType.34': 'Налог с дивидендов 15 %',
  'opType.35': 'Налог с материальной выгоды 15 %',
  'opType.36': 'Корректировка налога 15 %',
  'opType.37': 'Налог по РЕПО 15 %',
  'opType.38': 'Налог по РЕПО',
  'opType.39': 'Налог по РЕПО',
  'opType.40': 'Возврат налога по РЕПО',
  'opType.41': 'Налог по РЕПО 15 %',
  'opType.42': 'Возврат налога по РЕПО 15 %',
  'opType.43': 'Дивиденды на карту',
  'opType.44': 'Корректировка налога',
  'opType.45': 'Комиссия за валютный остаток',
  'opType.46': 'Комиссия за вывод валюты',
  'opType.47': 'Гербовый сбор',
  'opType.50': 'Вывод SWIFT',
  'opType.51': 'Пополнение SWIFT',
  'opType.53': 'Перевод на карту',
  'opType.54': 'Перевод с карты',
  'opType.55': 'Комиссия за вывод',
  'opType.56': 'Сервис «Советы»',
  'opType.57': 'Перевод бумаг с ИИС',
  'opType.58': 'Перевод бумаг между счетами',
  'opType.59': 'Перевод на другой счёт',
  'opType.60': 'Перевод с другого счёта',
  'opType.61': 'Овернайт: размещение',
  'opType.62': 'Комиссия',
  'opType.63': 'Доход от овернайта',
  'opType.64': 'Исполнение опциона',
  'opType.65': 'Исполнение фьючерса',
  // Quotes above the heatmap (docs/quotes/SPEC.md)
  'quotes.title': 'Котировки',
  'quotes.name.imoex2': 'IMOEX2',
  'quotes.name.rgbi': 'RGBI',
  'quotes.name.usd': 'Доллар США',
  'quotes.name.cny': 'Юань',
  'quotes.name.brent': 'Нефть Brent',
  'quotes.name.gas': 'Газ',
  'quotes.name.gold': 'Золото',
  // Market overview on «Рынки» (docs/market-overview/SPEC.md)
  'market.today.title': 'Рынок сегодня',
  'market.today.rvi': 'Индекс страха RVI',
  'market.today.rviHint': 'Индекс волатильности Мосбиржи: насколько сильно, по ожиданиям инвесторов, будет колебаться рынок акций в ближайший месяц. Растёт — больше тревоги, падает — спокойнее.',
  'market.today.rviMore': 'RVI считается по ценам опционов на индекс РТС на ближайшие 30 дней — как VIX в США. Когда инвесторы боятся резких движений, они дороже платят за страховку, и RVI растёт. Обычно он подскакивает при падении рынка, поэтому его и называют «индексом страха».',
  'market.today.level.calm': 'Спокойно',
  'market.today.level.normal': 'Обычно',
  'market.today.level.anxious': 'Тревожно',
  'market.today.level.panic': 'Паника',
  'market.today.levelAria': 'Шкала уровней RVI',
  'market.today.range.calm': 'до 25',
  'market.today.range.normal': '25–35',
  'market.today.range.anxious': '35–50',
  'market.today.range.panic': 'от 50',
  'market.today.rviScale': 'Границы — по истории RVI с 2015 года: в половине дней он был от 23,5 до 36,8 (середина — 29,7), выше 50 — только в кризисы (2020 — до 124, 2022 — до 143).',
  'market.today.breadth': 'Акции индекса',
  'market.today.up': 'Растут {count}',
  'market.today.down': 'Падают {count}',
  'market.today.flat': 'Без изменений {count}',
  'market.leaders.title': 'Лидеры дня',
  'market.leaders.modeAria': 'Лидеры роста или падения',
  'market.leaders.up': 'Рост',
  'market.leaders.down': 'Падение',
  'market.leaders.noneUp': 'Сегодня растущих акций в индексе нет',
  'market.leaders.noneDown': 'Сегодня падающих акций в индексе нет',
  'market.sectors.title': 'Секторы за день',
  'market.sectors.hint': 'Изменение с весами индекса',
  'market.noData': 'Нет данных',
  // Instrument screen (docs/instrument/SPEC.md)
  'instrument.notFound': 'Бумага не найдена',
  'instrument.loadFailed': 'Не удалось загрузить бумагу',
  'instrument.today': 'за день',
  'instrument.yours': 'У вас · {name}',
  'instrument.value': 'Стоимость',
  'instrument.quantity': 'Количество',
  'instrument.average': 'Средняя → текущая',
  'instrument.profit': 'Доходность',
  'instrument.tab.chart': 'График',
  'instrument.tab.news': 'Новости',
  'instrument.tab.dividends': 'Дивиденды',
  'instrument.tab.operations': 'Операции',
  'instrument.tab.calc': 'Расчёт',
  'tpay.failed': 'Не удалось загрузить расчёт',
  'tpay.title': 'Расчётная выплата за пай',
  'tpay.retry': 'Повторить',
  'tpay.accruedTitle': 'Накоплено на сегодня за пай',
  'tpay.asOf': 'на {date}',
  'tpay.noUnits': 'Пока нет данных о числе паёв для расчёта',
  'tpay.feeProgress': 'На покрытие комиссии: {covered} из {total}',
  'tpay.feesFirst': 'Первые поступления покрывают комиссию',
  'tpay.feesAccounted': 'Комиссия учтена',
  'tpay.monthForecast': 'Прогноз за месяц — {value} за пай',
  'tpay.withUnconfirmed': 'С учётом Т+1 — {value} за пай',
  'tpay.unconfirmedCoupons': 'Купоны без новости по фонду',
  'tpay.withUnconfirmedPerUnit': 'С учётом Т+1 на пай',
  'tpay.unconfirmedNote': 'К подтверждённым купонам добавлены купоны без новости, у которых наступила расчётная дата зачисления. Обычно это Т+1 рабочий день, задержка уточняется по истории облигации. Из общей суммы один раз вычтена комиссия за месяц, остаток разделён на паи. Неизвестный размер купона оценивается по прошлой выплате.',
  'tpay.todayFormula': 'Накоплено на сегодня',
  'tpay.receivedCoupons': 'Подтверждённые купоны',
  'tpay.feesCovered': 'На покрытие комиссии',
  'tpay.income': 'К выплате по фонду',
  'tpay.confirmedNote': 'Поступления подтверждены новостями фонда. Суммы и комиссия расчётные. Это доход в фонде, а не зачисление на ваш счёт.',
  'tpay.forecastFormula': 'Прогноз за месяц',
  'tpay.net': 'После налога {rate}% — {value}',
  'tpay.period': 'Период {start}–{end} · отсечка {record} · выплата до {pay}',
  'tpay.updated': 'Дата последнего расчёта: {time}',
  'tpay.formula': 'Как посчитано',
  'tpay.couponsSum': 'Купоны',
  'tpay.expectedPart': 'из них ожидается {value}',
  'tpay.feesLabel': 'вознаграждения',
  'tpay.unitsLabel': 'паи',
  'tpay.fees': 'Вознаграждения',
  'tpay.feesStatement': 'долг из справки о СЧА на {date} + оценка прочих расходов {rate} % СЧА в год / 12',
  'tpay.feesEstimate': 'оценка {rate} % СЧА в год / 12',
  'tpay.units': 'Паёв',
  'tpay.unitsStatement': 'из справки на {date}',
  'tpay.unitsSnapshot': 'СЧА {nav} ÷ цена пая {price}',
  'tpay.perUnit': 'На пай',
  'tpay.rules': 'Правила фонда',
  'tpay.statement': 'Справка о СЧА на {date}',
  'tpay.coupons': 'Купоны месяца · {count}',
  'tpay.noCoupons': 'Купонов пока нет',
  'tpay.couponDates': 'купон {coupon} · фиксация {fix} · зачисление {credit}',
  'tpay.qtyStatement': 'кол-во из справки на {date}',
  'tpay.qtyTrades': 'кол-во: справка на {date} + сделки фонда',
  'tpay.qtySnapshot': 'кол-во по составу {time}',
  'tpay.estimated': '(прошлый купон)',
  'tpay.status.credited': 'зачислен',
  'tpay.status.unconfirmed': 'ждём подтверждения',
  'tpay.status.amount_pending': 'уточняется сумма',
  'tpay.status.expected': 'ожидается',
  'tpay.status.after_period': 'после периода',
  'tpay.status.skipped': 'не учтён',
  'tpay.accuracy': 'Точность по прошлым месяцам',
  'tpay.accuracyNote': 'Тот же расчёт против выплаты из справки о СЧА. Пока нет ежечасных снимков, количество бумаг берётся из справки за прошлый месяц.',
  'tpay.month': 'Месяц',
  'tpay.forecastCol': 'Расчёт',
  'tpay.factCol': 'Факт',
  'tpay.diffCol': 'Разница',
  'instrument.operationsFailed': 'Не удалось загрузить операции',
  'instrument.noOperations': 'Операций с этой бумагой нет',
  'instrument.dividendsFailed': 'Не удалось загрузить дивиденды',
  'instrument.noDividends': 'Дивидендов не было',
  'instrument.payment': 'выплата {date}',
  'instrument.dividendMark': 'Дивиденд {amount} · отсечка {date}',
  'instrument.dividendStatus.paid': 'выплачен',
  'instrument.dividendStatus.awaiting': 'ожидает выплаты',
  'instrument.dividendStatus.approved': 'утверждён',
  'instrument.dividendStatus.recommended': 'рекомендован',
  'instrument.dividendStatus.forecast': 'прогноз',
  'instrument.periodAria': 'Период графика',
  'instrument.period.1d': '1Д',
  'instrument.period.1w': '1Н',
  'instrument.period.1m': '1М',
  'instrument.period.1y': '1Г',
  'instrument.period.5y': '5Л',
  'instrument.periodLabel.1d': 'за день',
  'instrument.periodLabel.1w': 'за неделю',
  'instrument.periodLabel.1m': 'за месяц',
  'instrument.periodLabel.1y': 'за год',
  'instrument.periodLabel.5y': 'за 5 лет',
  'instrument.period.all': 'Всё',
  'instrument.periodLabel.all': 'за всё время',
  'instrument.trading': 'Торги',
  'instrument.fundamentals': 'Показатели',
  'instrument.fundamentalsSource': 'T-Инвестиции, за последние 12 месяцев и последний отчёт',
  'instrument.fGroup.valuation': 'Оценка',
  'instrument.fGroup.debt': 'Долг',
  'instrument.fGroup.profitability': 'Рентабельность',
  'instrument.fGroup.financials': 'Финансы за 12 месяцев',
  'instrument.fGroup.dividends': 'Дивиденды',
  'instrument.fGroup.other': 'Прочее',
  'instrument.f.debt': 'Долг',
  'instrument.f.netDebtEbitda': 'Чистый долг / EBITDA',
  'instrument.f.debtEquity': 'Долг / капитал',
  'instrument.f.netMargin': 'Чистая маржа',
  'instrument.f.revenue': 'Выручка',
  'instrument.f.netIncome': 'Чистая прибыль',
  'instrument.f.fcf': 'Свободный денежный поток',
  'instrument.f.dividendYield': 'Дивидендная доходность',
  'instrument.f.payout': 'Доля прибыли на дивиденды',
  'instrument.f.beta': 'Бета',
  'instrument.f.range52w': 'Мин — макс за 52 недели',
  'instrument.f.shares': 'Акций в обращении',
  'instrument.chartFailed': 'Не удалось загрузить график',
  'instrument.noChart': 'Нет данных для графика',
  'instrument.newsFailed': 'Не удалось загрузить новости',
  'instrument.noNews': 'Новостей пока нет',
  // Heatmap (docs/heatmap/SPEC.md)
  'heatmap.title': 'Тепловая карта акций',
  'heatmap.modeAria': 'Какие бумаги',
  'heatmap.mode.index': 'Индекс',
  'heatmap.mode.portfolio': 'Мой портфель',
  'heatmap.portfolio': 'Портфель',
  'heatmap.loadFailed': 'Не удалось загрузить карту',
  'heatmap.noShares': 'В портфеле «{name}» нет акций',
  'heatmap.noSharesHint': 'Облигации и фонды на карте не показываются',
  'heatmap.showIndex': 'Смотреть индекс',
  'heatmap.noData': 'Данные рынка ещё загружаются',
  'heatmap.sharePart': 'Доля {value} %',
  'heatmap.turnoverShort': 'Оборот {value}',
  'heatmap.tileAria': '{ticker}, {name}, {change}',
  'heatmap.noChange': 'изменение неизвестно',
  'heatmap.plus': 'плюс {value}',
  'heatmap.minus': 'минус {value}',
  'heatmap.mapAria': 'Тепловая карта, плиток: {count}',
  'heatmap.turnover': 'Оборот за день',
  'heatmap.capitalization': 'Капитализация',
  'heatmap.indexWeight': 'Вес в индексе',
  'heatmap.today': 'Сегодня',
  'heatmap.showAll': 'Смотреть все',
  'heatmap.allTitle': 'Все бумаги',
  'heatmap.turnoverOn': 'Оборот за {date}',
  'heatmap.updatedToday': 'Обновлено сегодня в {time}',
  'heatmap.updatedOn': 'Обновлено {date} в {time}',
  'heatmap.share': 'Поделиться картой',
  'heatmap.copy': 'Скопировать карту',
  'heatmap.copied': 'Карта скопирована',
  'heatmap.copyFailed': 'Не удалось скопировать карту',
  'heatmap.shareFailed': 'Не удалось поделиться картой',
};
